module.exports = __webpack_public_path__ + "img/qingdao_shili_dong.16ef07ed.png";